import { render, staticRenderFns } from "./FormActionButton.vue?vue&type=template&id=28393efa&"
import script from "./FormActionButton.vue?vue&type=script&lang=js&"
export * from "./FormActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports